"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_CART_STATE = 'Active';
exports.CART_SUPPLY_CHANNEL = 'warehouse';
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const mxp_schemas_1 = require("mxp-schemas");
const access_1 = require("../access");
const utils_1 = require("../utils");
const freeTrials_1 = require("./freeTrials");
__export(require("./freeTrials"));
const firmAdmin_1 = require("../firmAdmin");
const user_1 = require("../user");
exports.generateAddCartAction = (item, quantity, priceChannelId, bundleId, standingOrder, recurrentOrder, previousOrders, donationPrice, freeTrial, fullProductPriceChannelId, currencyLabel, userLocation, useProductsPriceCurrency, overrideDates, externalPrice, isCimaMembershipZeroPrice) => {
    var _a, _b, _c;
    const freeTrialCustomFields = {
        purchase_type: mxp_schemas_1.Product.FreeTrials.FULL,
        full_product_price_channel: priceChannelId,
    };
    if (freeTrial) {
        freeTrialCustomFields.purchase_type = mxp_schemas_1.Product.FreeTrials.FREE_TRIAL;
        freeTrialCustomFields.full_product_price_channel = fullProductPriceChannelId;
    }
    const standingOrderDiscount = Boolean(standingOrder || recurrentOrder)
        ? {
            standing_order_discount: standingOrder
                ? mxp_schemas_1.Product.StandingOrderEligible.STANDING_NEW
                : mxp_schemas_1.Product.StandingOrderEligible.STANDING_REORDER,
        }
        : {};
    const accessData = {};
    if (access_1.shouldCalculateAccess(item)) {
        accessData.access_start_datetime = access_1.calculateStartDate(access_1.AccessRetrievalMethod.ForceCalculation, item, previousOrders).toISOString();
        if (!access_1.isAutoRenewableProduct(item)) {
            // Auto renewable products are open ended
            accessData.access_end_datetime = access_1.calculateEndDate(access_1.AccessRetrievalMethod.ForceCalculation, new Date(accessData.access_start_datetime), item).toISOString();
        }
    }
    if (freeTrial && item.freeTrialEligible && item.freeTrialTerm) {
        accessData.access_end_datetime = moment_timezone_1.default().add(item.freeTrialTerm, 'days').toDate().toISOString();
    }
    if (overrideDates) {
        accessData.access_start_datetime = moment_timezone_1.default(overrideDates.startDate).toDate().toISOString();
        accessData.access_end_datetime = moment_timezone_1.default(overrideDates.expirationDate).toDate().toISOString();
    }
    const bundleIdField = Boolean(bundleId)
        ? {
            bundle_id: { typeId: 'product', id: bundleId },
        }
        : {};
    return Object.assign(Object.assign(Object.assign({ action: 'addLineItem', sku: item.sku, quantity, distributionChannel: {
            typeId: 'channel',
            id: priceChannelId,
        }, supplyChannel: {
            typeId: 'channel',
            key: exports.CART_SUPPLY_CHANNEL,
        }, custom: {
            type: {
                key: 'line-item-custom-fields',
            },
            fields: Object.assign(Object.assign(Object.assign(Object.assign({}, standingOrderDiscount), accessData), bundleIdField), freeTrialCustomFields),
        } }, (useProductsPriceCurrency &&
        externalPrice && {
        externalPrice: {
            currencyCode: currencyLabel || 'USD',
            centAmount: parseInt((_a = Number(externalPrice)) === null || _a === void 0 ? void 0 : _a.toFixed(2), 10),
        },
    })), (isCimaMembershipZeroPrice && {
        externalPrice: {
            currencyCode: currencyLabel || 'USD',
            centAmount: parseInt((_b = Number(0)) === null || _b === void 0 ? void 0 : _b.toFixed(2), 10),
        },
    })), (donationPrice && {
        externalPrice: {
            currencyCode: useProductsPriceCurrency ? currencyLabel || 'USD' : 'USD',
            centAmount: parseInt((_c = utils_1.toCentsFormat(Number(donationPrice))) === null || _c === void 0 ? void 0 : _c.toFixed(2), 10),
        },
    }));
};
exports.generateUpdateAccessDataActions = (lineItems, previousOrders) => lineItems.reduce((updateActions, lineItem) => {
    const originalAccessData = access_1.extractAccessDatesFromLineItem(lineItem);
    const updatedAccessData = {};
    if (access_1.shouldCalculateAccess(lineItem) && originalAccessData.accessStartDateTime) {
        // Only update if the start date exist
        const isFreeTrial = freeTrials_1.isLineItemFreeTrial(lineItem);
        updatedAccessData.accessStartDateTime = access_1.calculateStartDate(access_1.AccessRetrievalMethod.ForceCalculation, lineItem, previousOrders);
        if (originalAccessData.accessEndDateTime) {
            // Only update if the start and end date already exist
            updatedAccessData.accessEndDateTime = isFreeTrial
                ? freeTrials_1.getFreeTrialPeriodEndDate(lineItem).toDate()
                : access_1.calculateEndDate(access_1.AccessRetrievalMethod.ForceCalculation, updatedAccessData.accessStartDateTime, lineItem);
        }
        const accessStartDataChanged = updatedAccessData.accessStartDateTime &&
            updatedAccessData.accessStartDateTime.valueOf() !== originalAccessData.accessStartDateTime.valueOf();
        const accessEndDataChanged = updatedAccessData.accessEndDateTime &&
            updatedAccessData.accessEndDateTime.valueOf() !== originalAccessData.accessEndDateTime.valueOf();
        if (accessStartDataChanged) {
            // eslint-disable-next-line no-param-reassign
            updateActions = [
                ...updateActions,
                {
                    action: 'setLineItemCustomField',
                    lineItemId: lineItem.id,
                    name: access_1.LINE_ITEM_ACCESS_START_DATE,
                    value: updatedAccessData.accessStartDateTime.toISOString(),
                },
            ];
        }
        if (accessEndDataChanged) {
            // eslint-disable-next-line no-param-reassign
            updateActions = [
                ...updateActions,
                {
                    action: 'setLineItemCustomField',
                    lineItemId: lineItem.id,
                    name: access_1.LINE_ITEM_ACCESS_END_DATE,
                    value: updatedAccessData.accessEndDateTime.toISOString(),
                },
            ];
        }
    }
    return updateActions;
}, []);
exports.hasStackableItems = (cart) => Boolean(cart.lineItems.find((lineItem) => access_1.isStackingTopCandidate(lineItem)));
exports.sortCartItemsByBundleName = (a, b) => {
    var _a, _b;
    if (!a.bundleName) {
        return 1;
    }
    if (!b.bundleName) {
        return -1;
    }
    const bundleNameA = (_a = a === null || a === void 0 ? void 0 : a.bundleName) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const bundleNameB = (_b = b === null || b === void 0 ? void 0 : b.bundleName) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    return bundleNameA === null || bundleNameA === void 0 ? void 0 : bundleNameA.localeCompare(bundleNameB);
};
exports.NUMBER_OF_MONTHS_BEFORE_PRODUCT_START_MONTH_DO_WE_RENEW_IN_LAST_YEAR = 4;
exports.getCurrentRenewalSeason = (startMonth) => {
    const membershipProductStartMonth = moment_timezone_1.default(startMonth, 'MMMM').startOf('month');
    const modifier = membershipProductStartMonth >
        moment_timezone_1.default().add(exports.NUMBER_OF_MONTHS_BEFORE_PRODUCT_START_MONTH_DO_WE_RENEW_IN_LAST_YEAR, 'months')
        ? -1
        : 0;
    return membershipProductStartMonth.isValid()
        ? membershipProductStartMonth.add(modifier, 'year').format('YYYY')
        : moment_timezone_1.default().format('YYYY');
};
exports.calculateProration = (startMonth, endMonth, dateFormatter = 'MMM YYYY', rollbackStartDate, isRenewalSeason, isRenewal, isMembershipTypeChange, membershipZuoraTermEndDate, // NOTE: only used in sf create terms lambda
membershipZuoraTermStartDate, // NOTE: only used in sf create terms lambda and only passed in auto renewal lambda
applicationDateOverride, // will be used for FLP Switch to CIMA PQ scenario
isFlpUpgradingToAffiliate, removeProration, // for CR723 to remove proration during readmission journey
isActiveFcmaRenewal, isCimaFirmBilling) => {
    const currentYear = exports.getCurrentRenewalSeason(startMonth);
    // NOTE: if applicationDateOverride is undefined it will default to what the current day is.
    // applicationDateOverride will be used for FLP to CIMA PQ Switch Scenario.
    const applicationDate = rollbackStartDate
        ? moment_timezone_1.default(rollbackStartDate)
        : applicationDateOverride
            ? moment_timezone_1.default(applicationDateOverride)
            : moment_timezone_1.default().startOf('month');
    const membershipYear = moment_timezone_1.default(membershipZuoraTermEndDate).format('YYYY');
    const startMonthNum = moment_timezone_1.default(applicationDateOverride).month(startMonth).format('M');
    const endMonthNum = moment_timezone_1.default(applicationDateOverride).month(endMonth).format('M');
    const dateOfCandidateUpgrade = isFlpUpgradingToAffiliate ? moment_timezone_1.default(applicationDate) : undefined;
    const applicationDateStartMonth = !!applicationDateOverride
        ? moment_timezone_1.default(applicationDate)
        : applicationDate.startOf('month');
    let isSameYearComputedAndEndDate = false;
    let startDate;
    let endDate;
    let yearToUse = !!applicationDateOverride ? moment_timezone_1.default(applicationDateOverride).format('YYYY') : currentYear;
    const yearDifference = Number(membershipYear) - Number(currentYear);
    // only check year difference when renewing/upgrading for the next cycle
    // or if a user is paying late for an active (out of term) subscription -> January start month is excluded because in this case the end date is always the year before
    if ((yearDifference === 2 && (isRenewal || isMembershipTypeChange) && isRenewalSeason) ||
        (yearDifference === -1 && parseInt(startMonthNum, 10) !== 1 && isRenewal)) {
        yearToUse = membershipYear;
    }
    startDate = moment_timezone_1.default()
        .set({ year: parseInt(yearToUse, 10), month: parseInt(startMonthNum, 10) - 1 })
        .startOf('month');
    const yearToAdd = parseInt(startMonthNum, 10) === 1 ? 0 : 1;
    endDate = moment_timezone_1.default()
        .set({
        year: parseInt(yearToUse, 10) + yearToAdd,
        month: parseInt(endMonthNum, 10) - 1,
    })
        .endOf('month');
    if (firmAdmin_1.hasTruthyValue(removeProration, isActiveFcmaRenewal)) {
        const currentMonth = moment_timezone_1.default().format('M');
        const currentYearToday = moment_timezone_1.default().format('YYYY');
        if (parseInt(currentMonth, 10) < parseInt(startMonthNum, 10)) {
            // 1ST SCENARIO:
            // CYCLE START MONTH: APRIL
            // CURRENT DATE: JANUARY 2024
            // FULL CYCLE TO BE USED SHOULD BE: APRIL 2023 - APRIL 2024
            startDate = moment_timezone_1.default()
                .set({ year: parseInt(currentYearToday, 10) - 1, month: parseInt(startMonthNum, 10) - 1 })
                .startOf('month');
            endDate = moment_timezone_1.default()
                .set({ year: parseInt(currentYearToday, 10), month: parseInt(endMonthNum, 10) - 1 })
                .endOf('month');
            return {
                monthsProrated: 12,
                expirationDate: endDate.format(dateFormatter),
                daysProrated: 0,
                startDate: startDate.format(dateFormatter),
            };
        }
        // 2ND SCENARIO:
        // CYCLE START MONTH: JULY
        // CURRENT DATE: DECEMBER 2024
        // FULL CYCLE TO BE USED SHOULD BE: JULY 2024 - JULY 2025
        return {
            monthsProrated: 12,
            expirationDate: endDate.format(dateFormatter),
            daysProrated: 0,
            startDate: startDate.format(dateFormatter),
        };
    }
    // CASES:
    // B2C Signup
    // // startDate: sept, 2022
    // // endDate: aug, 2023
    // // currDate: march, 2022
    // // === endDate plus 1 year
    // B2C Renewal
    // // startDate: sept, 2022
    // // endDate: aug, 2023
    // // currDate: sept, 2022
    // // === endDate plus 1 year
    // B2C Renewal 3 month rule with 2 year gap
    // // membershiptermEndDate: 2024-01-31
    // // startDate: 2024-02-01
    // // endDate: 2025-01-31
    // Centers Signup
    // // start - jan 2022
    // // end - dec 2022
    // // curr - sept 2022
    // Centers Manual Renewal 2022
    // // start - jan 2022
    // // end - dec 2022
    // // curr - dec 2022
    // // if zuoraTermEndDateYear(2022-12-31) === currYear(2022)
    // // // === startDate and endDate plus 1
    // Centers Manual Renewal 2023 Feb
    // // start - jan 2023
    // // end - dec 2023
    // // curr - feb 2023
    // // if zuoraTermEndDateYear(2022-12-31) === currYear(2023)
    // // // === remain
    // Centers Manual Renewal 2023 Jan
    // // start - jan 2023
    // // end - dec 2023
    // // curr - jan 2023
    // // if zuoraTermEndDateYear(2022-12-31) === currYear(2023)
    // // // === remain
    // CIMA Manual Renewal 2022
    // start - jan 2022
    // end - dec 2022
    // membershipZuoraTermEndDate(2022-12-31) === currentYear(2022)
    // add 1 year both start and end
    // CIMA Manual Renewal 2023
    // start - jan 2023
    // end - dec 2023
    // membershipZuoraTermEndDate(2022-12-31) < currentYear
    // remains the same
    // CIMA auto Renewal 2022
    // start - jan 2022
    // end - dec 2022
    // if zuoraTermStartDate(2023-01-01) !== currYear(2022)
    // add 1 year both start and end
    // CIMA Auto Renewal 2023
    // start - jan 2023
    // end - dec 2023
    // if zuoraTermStartDate(2023-01-01) !== currYear(2023)
    // remains the same
    // Centers and CIMA Membership
    const renewalCondition = !!membershipZuoraTermStartDate
        ? // NOTE: can be same year to be returned in auto renew since the workaround in update terms in zuora.
            moment_timezone_1.default(membershipZuoraTermStartDate).format('YYYY') >= currentYear // for auto renewal condition
        : moment_timezone_1.default(membershipZuoraTermEndDate).format('YYYY') >= currentYear; // for manual renewal condition
    if (parseInt(startMonthNum, 10) === 1 &&
        renewalCondition &&
        (isRenewal || isMembershipTypeChange) &&
        isRenewalSeason &&
        !(isCimaFirmBilling && yearDifference === 0)
    // Year only added on when membership is not CIMA firm billing and yearDifference is not 0
    ) {
        startDate = moment_timezone_1.default() // startDate + 1 year
            .set({ year: parseInt(currentYear, 10) + 1, month: parseInt(startMonthNum, 10) - 1 })
            .startOf('month');
        endDate = moment_timezone_1.default() // startDate + 1 year
            .set({ year: parseInt(currentYear, 10) + 1, month: parseInt(endMonthNum, 10) - 1 })
            .endOf('month');
    }
    let expirationDate = endDate.endOf('month');
    let monthsProrated = 0;
    let daysProrated = 0;
    let newStartDate;
    let newExpirationDate;
    let startDateYearComputed;
    let endDateYearComputed;
    // check first if the passed termEndDate is the same already computed endDate so we can determine that
    // the user already purchase for the next cycle and wants to renew/upgrade/downgrade already.
    // endDate = 2022-07-31
    // membershipZuoraTermEndDate = 2022-07-31
    if (isRenewalSeason) {
        isSameYearComputedAndEndDate = moment_timezone_1.default(membershipZuoraTermEndDate).isSame(endDate, 'month');
    }
    // NOTE: this conditions would be use for createSFOrder lambda to determine our expiration and start date.
    if (isRenewal && isRenewalSeason) {
        if (isRenewalSeason && isSameYearComputedAndEndDate) {
            startDateYearComputed = moment_timezone_1.default(startDate).format('YYYY'); // 2022-08-01
            endDateYearComputed = moment_timezone_1.default(endDate).format('YYYY'); // 2023-07-31
            newStartDate = moment_timezone_1.default(startDate) // startDate + 1 year
                .set({
                year: parseInt(startDateYearComputed, 10) + 1,
                month: parseInt(startMonthNum, 10) - 1,
            })
                .startOf('month');
            newExpirationDate = moment_timezone_1.default(endDate) // startDate + 1 year
                .set({
                year: parseInt(endDateYearComputed, 10) + 1,
                month: parseInt(endMonthNum, 10) - 1,
            })
                .endOf('month');
            return {
                monthsProrated: 12,
                expirationDate: newExpirationDate.format(dateFormatter),
                daysProrated: daysProrated ? daysProrated + 1 : 0,
                startDate: newStartDate.format(dateFormatter),
            };
        }
        return {
            monthsProrated,
            expirationDate: expirationDate.format(dateFormatter),
            daysProrated: daysProrated ? daysProrated + 1 : 0,
            startDate: startDate.format(dateFormatter),
        };
    }
    if (isMembershipTypeChange) {
        // NOTE: there's an edge case scenario that if we're not comparing it to the first day of the month it will consider it to be 3 month rule
        // in case that 4/6/2022 and we're comparing to 8/1/2022 the result would be 3.++ and would be round off by Math floor resulting to value of 3.
        let monthDifference = Math.floor(startDate.diff(applicationDateStartMonth, 'months', true));
        // adding > 0 condition since we can renew even after the next startDate of membership cycle
        // and prevent overriding initial value generated.
        // membershipZuoraTermEndDate should be existing when doing type change
        if (firmAdmin_1.areAllTruthy(monthDifference <= 3, monthDifference > 0, !!membershipZuoraTermEndDate, !isRenewalSeason)) {
            startDate = applicationDate;
            monthsProrated = 12 + (monthDifference === 0 ? 1 : monthDifference);
            return {
                monthsProrated,
                expirationDate: expirationDate.format(dateFormatter),
                daysProrated: daysProrated ? daysProrated + 1 : 0,
                startDate: startDate.format(dateFormatter),
            };
        }
        // if outside renewal season get application start first day of the month.
        if (!isRenewalSeason) {
            startDate = applicationDateStartMonth;
            // get month difference between endDate and applicationDate if within 3 month rule to add 1 year in order to get correct term dates.
            const applicationMonthAndEndDateMonthDifference = Math.ceil(endDate.diff(applicationDateStartMonth, 'months', true));
            if (firmAdmin_1.areAllTruthy(applicationMonthAndEndDateMonthDifference <= 3, applicationMonthAndEndDateMonthDifference > 0)) {
                expirationDate = endDate.add(1, 'years');
                monthDifference = 12 + applicationMonthAndEndDateMonthDifference;
            }
            else if (monthDifference > 3) {
                expirationDate = endDate.subtract(1, 'years');
            }
        }
        if (isRenewalSeason && isSameYearComputedAndEndDate) {
            startDateYearComputed = moment_timezone_1.default(startDate).format('YYYY');
            endDateYearComputed = moment_timezone_1.default(endDate).format('YYYY');
            newStartDate = moment_timezone_1.default(startDate) // startDate + 1 year
                .set({
                year: parseInt(startDateYearComputed, 10) + 1,
                month: parseInt(startMonthNum, 10) - 1,
            })
                .startOf('month');
            newExpirationDate = moment_timezone_1.default(endDate) // startDate + 1 year
                .set({
                year: parseInt(endDateYearComputed, 10) + 1,
                month: parseInt(endMonthNum, 10) - 1,
            })
                .endOf('month');
            return {
                monthsProrated: 12,
                expirationDate: newExpirationDate.format(dateFormatter),
                daysProrated: daysProrated ? daysProrated + 1 : 0,
                startDate: newStartDate.format(dateFormatter),
            };
        }
        return {
            monthsProrated: user_1.conditionalFunction(isRenewalSeason, 0, monthDifference),
            expirationDate: expirationDate.format(dateFormatter),
            daysProrated: daysProrated ? daysProrated + 1 : 0,
            startDate: startDate.format(dateFormatter),
        };
    }
    // NOTE: this our existing proration functionality
    // Is inside the membership calendar year
    // adding isSame condition since there's edge case scenario where a customer applied on the very first month of the start month
    // causing our proration banner to appear which we don't need to show.
    if (applicationDate.isBetween(startDate, endDate) || applicationDateStartMonth.isSame(startDate)) {
        const monthDifference = Math.floor(applicationDate.diff(startDate, 'months', true));
        if (firmAdmin_1.areAllTruthy(monthDifference === 0, !isFlpUpgradingToAffiliate)) {
            // no proration
            return {
                monthsProrated,
                expirationDate: endDate.format(dateFormatter),
                daysProrated,
                startDate: startDate.format(dateFormatter),
            };
        }
        monthsProrated = 12 - monthDifference;
        const prorationStartDate = isFlpUpgradingToAffiliate ? dateOfCandidateUpgrade : applicationDateStartMonth;
        daysProrated = Math.floor(expirationDate.diff(prorationStartDate, 'days', true));
        // add condition for three month rule for within the current cycle application.
        // determine if the prorated month is less than or equal to 3
        // so we can determine if we need to adjust dates so we can include next cycle as well for the three month rule.
        if (monthsProrated <= 3 && monthsProrated > 0 && !isFlpUpgradingToAffiliate) {
            monthsProrated = 12 + monthsProrated;
            daysProrated = Math.floor(expirationDate.add(1, 'y').diff(applicationDateStartMonth, 'days', true));
        }
    }
    else {
        const monthDifference = Math.ceil(startDate.diff(applicationDate, 'months', true));
        // adding > 0 condition since we can renew even after the next startDate of membership cycle
        // and prevent overriding initial value generated.
        if (monthDifference <= 3 && monthDifference > 0) {
            monthsProrated = 12 + (monthDifference === 0 ? 1 : monthDifference);
            daysProrated = Math.floor(expirationDate.diff(applicationDateStartMonth, 'days', true));
        }
        else {
            monthsProrated = monthDifference;
            expirationDate = endDate.subtract(1, 'years');
            daysProrated = Math.floor(expirationDate.diff(applicationDateStartMonth, 'days', true));
        }
    }
    return {
        monthsProrated,
        expirationDate: expirationDate.format(dateFormatter),
        daysProrated: daysProrated ? daysProrated + 1 : 0,
        startDate: applicationDateStartMonth.format(dateFormatter),
    };
};
exports.isMembershipCart = (cart) => !!cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.MEMBERSHIP ||
    lineItem.productType === mxp_schemas_1.Product.ProductType.CENTER_MEMBERSHIP ||
    lineItem.productType === mxp_schemas_1.Product.ProductType.FLP);
exports.isCredentialSectionCart = (cart) => !!cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.CREDENTIAL || lineItem.productType === mxp_schemas_1.Product.ProductType.SECTION);
exports.isFLPCart = (cart) => !!cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.FLP);
exports.isCenterMembershipCart = (cart) => !!cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.CENTER_MEMBERSHIP);
exports.membershipLineItemInCart = (cart) => cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.MEMBERSHIP ||
    lineItem.productType === mxp_schemas_1.Product.ProductType.CENTER_MEMBERSHIP ||
    lineItem.productType === mxp_schemas_1.Product.ProductType.FLP);
exports.membershipOnlyLineItemInCart = (cart) => cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.MEMBERSHIP);
exports.flpOnlyLineItemInCart = (cart) => cart.lineItems.find(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.FLP);
exports.sectionCartLineItems = (cart) => { var _a; return (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.filter(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.SECTION); };
exports.credentialCartLineItems = (cart) => { var _a; return (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.filter(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.CREDENTIAL); };
exports.flpCartLineItems = (cart) => { var _a; return (_a = cart === null || cart === void 0 ? void 0 : cart.lineItems) === null || _a === void 0 ? void 0 : _a.filter(lineItem => lineItem.productType === mxp_schemas_1.Product.ProductType.FLP); };
exports.calculateCartDiscount = (cart, calculateByQuantity) => {
    return cart.lineItems.reduce((acc, lineItem) => {
        var _a, _b, _c, _d;
        const centAmount = ((_c = (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.discountedPricePerQuantity[0]) === null || _a === void 0 ? void 0 : _a.discountedPrice.includedDiscounts[0]) === null || _b === void 0 ? void 0 : _b.discountedAmount) === null || _c === void 0 ? void 0 : _c.centAmount) || 0;
        const quantity = calculateByQuantity ? ((_d = lineItem === null || lineItem === void 0 ? void 0 : lineItem.discountedPricePerQuantity[0]) === null || _d === void 0 ? void 0 : _d.quantity) || 0 : 1;
        return acc + centAmount * quantity;
    }, 0);
};
exports.SubtractDaysToDate = (date, daysToSubtract) => {
    return moment_timezone_1.default(date).subtract(daysToSubtract, 'days').format('YYYY-MM-DD');
};
//# sourceMappingURL=index.js.map